import { Injectable, OnDestroy } from '@angular/core';
import { Constants, EVENT_NAMES, EVENT_TYPES, LEADSOURCE } from '@app/constants';
import { BehaviorSubject, Subject, Subscription, lastValueFrom, takeUntil, timer } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Data, LeadResponse } from '../model/lead.modal';
import { TelephonyProvider } from '../providers/telephony/telephony.provider';
import { ProviderService } from './provider.service';
import { ToastService } from './toast/toast.service';
import { CallType } from '../features/call/interfaces/CallType/CallType';
import { AppConfigurationService } from './app.configuration.service';
import { AuthenticationService } from '@app/core';
import { SignalrService } from '@app/core/signalr.service';
import { RealTimeEvents } from '@app/core/signalr.events';
import { TelephonyStateService } from '../providers/telephony/telephony.state.service';
import { momentCustomInstance as moment } from '@projects/shared/src/app/utils/helper';
import { LoaderService } from '@app/core/loader.service';
@Injectable({
  providedIn: 'root',
})
export class OutboundDialerService implements OnDestroy {
  isModalOpen$ = new BehaviorSubject<boolean>(false);
  template$ = new BehaviorSubject<string>('');
  isDialEnabled$ = new BehaviorSubject<boolean>(false);
  leadModel$ = new BehaviorSubject<any>({});
  lead!: LeadResponse;
  scriptQuestions: Array<any> = [];
  subscriptions = new Array<Subscription>();
  type = '';
  phone_number = '';
  lead_id = '';
  lead_source = '';
  direction$ = new BehaviorSubject<CallType>(CallType.Outbound);
  count$ = new BehaviorSubject<number>(0);
  leadMonitorSubscription!: Subscription;
  callSubscription!: Subscription;
  countryCode = '';
  primaryCallSid = '';
  dialInProgress = false;
  outboundTimeout!: any;
  outboundRequest!: any;
  private cancelRequest$ = new Subject<void>();
  timeout = 60;
  constructor(
    private http: HttpClient,
    private telephony: TelephonyProvider,
    private providerService: ProviderService,
    private toastService: ToastService,
    private appConfig: AppConfigurationService,
    private authService: AuthenticationService,
    private signalrService: SignalrService,
    private telephonyState: TelephonyStateService,
    private loaderService: LoaderService,
    
  ) {
    providerService.isSTAR_LINK_Call;
    this.subscriptions.push(
      this.telephony.voice.events.subscribe((event) => {
        switch (event.type) {
          case EVENT_TYPES.OutboundDialer: {
            switch (event.name) {
              case EVENT_NAMES.Callback: {
                const {
                  phone_number,
                  type,
                  data,
                  lead_source,
                  lead_id,
                  countryCode,
                  pass_lead,
                  scrub_disposition,
                  dial_count,
                  campaign_code,
                  primary_call_sid,
                } = event.data;
                this.lead_id = lead_id;
                this.primaryCallSid = primary_call_sid;
                this.setLeadIdLocal(lead_id);
                this.type = type;
                this.phone_number = phone_number;
                this.lead_source = lead_source;
                this.countryCode = countryCode;
                this.direction$.next(CallType.Outbound);
                let model = JSON.parse(data) || {};
                switch (lead_source) {
                  case LEADSOURCE.HUBSPOT:
                    let { Questions } = this.providerService.metadata$.getValue();
                    let questions = [...(Questions || [])];
                    questions.forEach((q) => {
                      q.ans = model[q.key];
                    });
                    model.Questions = questions;
                    this.scriptQuestions = questions ?? [];
                    this.template$.next(LEADSOURCE.HUBSPOT);
                    break;
                  case LEADSOURCE.ZIPLY:
                    this.template$.next(LEADSOURCE.ZIPLY);
                    break;
                  case LEADSOURCE.TIKTOK:
                    this.template$.next(LEADSOURCE.TIKTOK);
                    break;
                }
                model.IsFrontDesk = scrub_disposition == 'FDC';
                model.DialCount = dial_count ?? '0';
                this.leadModel$.next(model);
                this.setDialEnabled(true);
                this.isModalOpen$.next(true);
                this.startLeadDialMonitor();
                //only sending lead if if dialing from assigned lead tabs
                if (!pass_lead) {
                  let id = '';
                  let codes =
                    this.appConfig.getByIdentifier('ScriptSkillCodesAndTFNS').Fields['STAR_LINK_SKILLCODE'] ??
                    Constants['STAR_LINK_SKILLCODE'];
                  if (codes.includes(campaign_code)) {
                    id = lead_id;
                  }
                  this.telephony.voice.events.next({
                    type: EVENT_TYPES.OutboundDialer,
                    name: EVENT_NAMES.LeadSet,
                    data: id,
                  });
                }
                this.providerService.setupLeadData(this.leadModel$.getValue(), this.lead_source);
                break;
              }
              case EVENT_NAMES.Init: {
                this.cancelOutboundRequest();
                console.log(new Date().toLocaleString() + '  ➤  OutboundDialerService => EVENT_TYPES.OutboundDialer => EVENT_NAMES.Init ');
                const { campaignId, lead_id, email, phone_number, direction, type } = event.data;
                this.type = type;
                this.direction$.next(direction);
                this.getLead(campaignId, phone_number, email, lead_id, direction);
                break;
              }
              case EVENT_NAMES.Started:
                this.isModalOpen$.next(false);
                this.isDialEnabled$.next(false);
                break;
              case EVENT_NAMES.FetchLead: {
                this.direction$.next(CallType.Outbound);
                this.outboundTimeout = setTimeout(() => {
                  this.toastService.info('Fetching new lead ... ');
                  this.getCampaignLead();
                }, 1000);
                break;
              }
            }
            break;
          }
          case EVENT_TYPES.Reservation:
            switch (event.name) {
              case 'rejected':
              case 'timeout':
              case 'canceled':
              case 'rescinded':
              case 'error':
                this.isModalOpen$.next(false);
                this.isDialEnabled$.next(false);
                break;
            }
            break;
          case EVENT_TYPES.Call:
            switch (event.name) {
              case EVENT_NAMES.Accepted:
                //* Dialed Lead Id Save on lcoal storage
                // if (this.lead_id) {
                if (this.authService.getTelephonyProvider() != 'ibex') {
                  this.providerService.setupLeadData(this.leadModel$.getValue(), this.lead_source);
                }


                this.cancelOutboundRequest();
                // }
                this.isModalOpen$.next(false);
                this.isDialEnabled$.next(false);
                this.endLeadDialMonitor();
                this.endCallMonitor();
                this.count$.next(0);
                break;
              case 'disconnect':
              case 'dispose':
                this.scriptQuestions = [];
                this.isModalOpen$.next(false);
                this.isDialEnabled$.next(false);
                this.endLeadDialMonitor();
                this.endCallMonitor();
                this.type = '';
                this.phone_number = '';
                this.lead_id = '';
                this.lead_source = '';
                this.leadModel$.next({});
                this.primaryCallSid = '';
                break;
              case 'wrong-dialing':
              case 'close-modal':
                this.isModalOpen$.next(false);
                this.isDialEnabled$.next(false);
                this.endLeadDialMonitor();
                this.endCallMonitor();
                this.type = '';
                this.phone_number = '';
                this.lead_id = '';
                this.lead_source = '';
                this.leadModel$.next({});
                this.primaryCallSid = '';
                break;
            }
            break;
          case 'Activity': {
            switch (event.name) {
              case 'update': {
                const { activity, date } = event.data;
                if (activity == Constants.STATUSES.Outbound.FriendlyName) {
                  this.toastService.info('Fetching new lead ... ');
                  setTimeout(() => {
                    this.loaderService.toggleMainLoader(true);
                  }, 800);
                  this.outboundTimeout = setTimeout(() => {
                    this.loaderService.toggleMainLoader(false);
                    this.getCampaignLead();
                  }, 4000);
                }
              }
            }
          }
        }
      })
    );
    this.subscriptions.push(
      this.signalrService.listen(RealTimeEvents.LeadsAvailableForDial).subscribe((call: any) => {
        console.log(`SignalR event => LeadsAvailableForDial received, OnCall ${this.telephonyState.onCall}`);
        if (!this.telephonyState.onCall && this.isModalOpen$.getValue() == false) {
          this.getCampaignLead();
        }
      })
    );
  }
  ngOnDestroy(): void {
    this.subscriptions.forEach((x) => {
      x.unsubscribe();
    });
  }
  async getLead(campaignId: string, phone: string, email: string, leadId: string, direction: number) {
    if (phone.toLowerCase() === 'anonymous') {
      console.log(new Date().toLocaleString() + '  ➤  OutboundDialerService => Phone is anonymous , accepting call directly');
      this.dialCall();
      return;
    }
    const url = `${Constants.OUTBOUND_DIALER.GET_LEAD}/${campaignId}?phoneNumber=${encodeURIComponent(
      phone.toLowerCase()
    )}&email=${email}&leadId=${leadId}&direction=${direction}`;
    console.log(`OutboundDialerService => getLead ${url}`);
    const lead = await lastValueFrom(this.http.get<LeadResponse>(url));
    if (!lead?.Id) {
      console.log(new Date().toLocaleString() + '  ➤  OutboundDialerService => Lead not found in database');
      console.log(new Date().toLocaleString() + '  ➤  OutboundDialerService => Dialing call');
      if (direction == CallType.Inbound) {
        this.dialCall();
        return;
      } else {
        console.log(new Date().toLocaleString() + '  ➤  OutboundDialerService => Marking call as complete forcefully');
        this.telephony.voice.events.next({
          type: EVENT_TYPES.OutboundDialer,
          name: EVENT_NAMES.ForceComplete,
          data: '',
        });
      }
      return;
    }
    let data = lead.Data as Data;
    if (data === null || data.Payload === null || data.Payload.length === 0) {
      console.log(new Date().toLocaleString() + '  ➤  OutboundDialerService => Lead data is null , accepting call directly');
      this.dialCall();
      return;
    }

    let model = JSON.parse(lead.Data.Payload);
    if (model === null) {
      console.log(new Date().toLocaleString() + '  ➤  OutboundDialerService => Lead model is null , accepting call directly');
      this.dialCall();
      return;
    }
    this.lead = lead;
    this.setLeadIdLocal(lead.Id);
    this.lead_source = lead.LeadSource;

    switch (lead.LeadSource) {
      case LEADSOURCE.HUBSPOT:
        let { Questions } = this.providerService.metadata$.getValue();
        let questions = [...(Questions || [])];
        questions.forEach((q) => {
          q.ans = model[q.key];
        });
        model.Questions = questions;
        this.scriptQuestions = questions ?? [];
        this.template$.next(LEADSOURCE.HUBSPOT);
        break;
      case LEADSOURCE.ZIPLY:
        this.template$.next(LEADSOURCE.ZIPLY);
        break;
      case LEADSOURCE.TIKTOK:
        this.template$.next(LEADSOURCE.TIKTOK);
        break;
    }
    model.IsFrontDesk = lead.ScrubDisposition == 'FDC';
    model.DialCount = lead.DialCount;
    this.leadModel$.next(model);
    this.setDialEnabled(true);
    this.isModalOpen$.next(true);
    if (this.direction$.getValue() == CallType.Inbound) {
      this.startCallMonitor(5);
    } else {
      this.startCallMonitor(this.timeout);
    }
    this.providerService.setupLeadData(this.leadModel$.getValue(), this.lead_source);
  }
  async getCampaignLead() {
    this.outboundTimeout = null;
    this.cancelRequest$ = new Subject<void>();
    const campaigns = this.authService.getAllCampaigns();
    if (!campaigns) {
      console.error('No user campaigns found');
      return;
    }
    const url = `${Constants.OUTBOUND_DIALER.GET_CAMPAIGN_LEAD}?campaignId=${campaigns[0].Id}`;
    let leadPayload: any = null;
    try {
      leadPayload = await lastValueFrom(this.http.get(url).pipe(takeUntil(this.cancelRequest$)));
    } catch (error) {
      console.error('Error fetching lead', error);
      return;
    }
    if (!leadPayload.IsSuccess || !leadPayload.Lead) {
      console.error(leadPayload.Message || 'Failed to fetch lead');
      this.toastService.info(leadPayload.Message || 'No leads found');
      return;
    }
    let lead: any = leadPayload.Lead;
    let data = lead.CustomerData;
    if (data === null || data.length == 0) {
      console.log(new Date().toLocaleString() + '  ➤  OutboundDialerService 1=> Lead data is null or empty');
      return;
    }
    data = data.find((x: any) => x.PhoneNumber == lead.PhoneNumber);
    if (!data) {
      console.log(new Date().toLocaleString() + '  ➤  OutboundDialerService 2=> Lead data is not found for phone');
      return;
    }
    let model = JSON.parse(data.Payload);
    if (model === null) {
      console.log(new Date().toLocaleString() + '  ➤  OutboundDialerService => Lead model is null');
      return;
    } 
    try {
      model.CreatedDate = moment(data.CreatedOn).format('MMMM Do YYYY, h:mm:ss a')
    } catch (error) {
      console.error('Error parsing lead data', error);
    }
    this.lead_id = lead.Id;
    this.primaryCallSid = '';
    this.setLeadIdLocal(lead.Id);
    this.type = 'preview-dialer';
    this.phone_number = lead.PhoneNumber;
    this.lead_source = lead.LeadSource;
    this.countryCode = lead.CountryCode;
    this.lead = lead;
    switch (lead.LeadSource) {
      case LEADSOURCE.HUBSPOT:
        let { Questions } = this.providerService.metadata$.getValue();
        let questions = [...(Questions || [])];
        questions.forEach((q) => {
          q.ans = model[q.key];
        });
        model.Questions = questions;
        this.scriptQuestions = questions ?? [];
        this.template$.next(LEADSOURCE.HUBSPOT);
        break;
      case LEADSOURCE.ZIPLY:
        this.template$.next(LEADSOURCE.ZIPLY);
        break;
      case LEADSOURCE.TIKTOK:
        this.template$.next(LEADSOURCE.TIKTOK);
        break;
    }
    this.direction$.next(CallType.Outbound);
    model.IsFrontDesk = lead.ScrubDisposition == 'FDC';
    model.DialCount = lead.DialCount;
    this.leadModel$.next(model);
    this.setDialEnabled(true);
    this.isModalOpen$.next(true);
    this.startCallMonitor(this.timeout);
    this.providerService.setupLeadData(this.leadModel$.getValue(), this.lead_source);
  }
  setDialEnabled(value: boolean) {
    this.isDialEnabled$.next(value);
  }
  dialCall() {
    const provider = this.authService.getTelephonyProvider();
    if (provider == 'ibex' && this.direction$.getValue() == CallType.Inbound) { // return in case of ibex dialer call auto acceptted in dialer
      this.isModalOpen$.next(false);
      this.isDialEnabled$.next(false);
      this.endLeadDialMonitor();
      this.endCallMonitor();
      this.count$.next(0);
      return;
    }
    if (this.type == 'reservation') {
      this.telephony.voice.acceptCall();
    } else if (this.type == 'callback' || this.type == 'preview-dialer' || this.type == 'assigned-lead') {
      this.telephony.voice.makeCall(
        null,
        this.phone_number,
        'outbound',
        {},
        '',
        {},
        this.countryCode,
        this.primaryCallSid,
        this.type
      );
    }
  }
  startLeadDialMonitor() {
    this.endLeadDialMonitor();
    let interval = 0;
    this.leadMonitorSubscription = timer(0, 1000).subscribe((x: number) => {
      interval++;
      if (interval >= this.timeout) {
        if (this.isModalOpen$.getValue()) {
          this.isModalOpen$.next(false);
          this.toastService.info('Lead timeout.');
        }
      }
    });
  }
  endLeadDialMonitor() {
    if (this.leadMonitorSubscription) {
      this.leadMonitorSubscription.unsubscribe();
    }
  }
  setLeadIdLocal(id: string) {
    this.lead_id = id;
    localStorage.setItem('current_lead_id', id);
    this.telephony.voice.events.next({
      type: EVENT_TYPES.OutboundDialer,
      name: EVENT_NAMES.LeadSet,
      data: id,
    });
  }
  startCallMonitor(interval: number) {
    this.endCallMonitor();
    this.count$.next(interval);
    this.callSubscription = timer(0, 1000).subscribe((x: number) => {
      interval--;
      this.count$.next(interval);
      if (interval <= 2) {
        this.setDialEnabled(false);
      }
      if (interval == 0) {
        this.endCallMonitor();
        this.dialCall();
      }
    });
  }
  endCallMonitor() {
    if (this.callSubscription) {
      this.callSubscription.unsubscribe();
    }
  }
  cancelOutboundRequest() {
    clearTimeout(this.outboundTimeout);
    this.cancelRequest$.next(); // Emits to cancel
    this.cancelRequest$.complete(); // Completes the Subject
    this.isModalOpen$.next(false);
    this.isDialEnabled$.next(false);
    this.endLeadDialMonitor();
    this.endCallMonitor();
    this.type = '';
    this.phone_number = '';
    this.lead_id = '';
    this.lead_source = '';
    this.leadModel$.next({});
    this.primaryCallSid = '';
  }
}
